import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <CardsSection />
        <RankingSection />
        <TopicsSection />
        <AppSection />
        <MediaSection />
        <UpdatesSection />
        <ContactSection />
        <AboutSection />
        <CommentsSection />
        <IndexSection />
        <FeaturesSection />
        <FaqSection />
      </main>
      <Footer />
    </>
  );
}